module.exports = __webpack_public_path__ + "static/media/svg-stat-mailing.606f1d12.svg";